import { Modal, Box, Button } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import '../translations.js';

const ConfirmDownloadModal = ({ open, onClose, onConfirm, startDate, endDate }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Format dates using dayjs
  const formattedStartDate = dayjs(startDate).format('DD.MM.YYYY');
  const formattedEndDate = dayjs(endDate).format('DD.MM.YYYY');

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          p: isMobile ? 2 : 3,
          width: isMobile ? '80%' : '90%',
          maxWidth: 400,
        }}
      >
        <div className="modal-title" style={{ marginBottom: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '20px' }}>{t('confirm_download')}</h2>
        </div>
        <p style={{ fontSize: '16px', marginBottom: '30px' }}>
          {t('are_you_sure_download')} <strong>{formattedStartDate}</strong> - <strong>{formattedEndDate}</strong>?
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: '#5616ea', // text color
              borderColor: '#5616ea', // border color
              '&:hover': {
                borderColor: '#5e0fb3',
                backgroundColor: '#f3eaff', // optional hover background
              },
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: '#5616ea',
              '&:hover': {
                backgroundColor: '#4a14d6',
              },
            }}
          >
            {t('confirm')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDownloadModal;
